import React from "react";
import HeadingComponent from "../UserInterface/HeadingComponent";
import LayoutCenter from "../UserInterface/LayoutCenter";
import GoIllusList from "./GoIllusList";

export const HCGoTerms = () => {
  const termsList = [
    {
      imageUrl: "/static/images/svg/icon-usiasvg.svg",
      descText: "Berusia 17 – 65 tahun",
    },
    {
      imageUrl: "/static/images/svg/ktpsvg.svg",
      descText: "Memiliki e-KTP aktif & data terbaca jelas",
    },
    {
      imageUrl: "/static/images/svg/rekening-aktif.svg",
      descText: "Memiliki nomor rekening bank yang aktif",
    },
  ];
  return (
    <div className="hcgo-terms-wrapper">
      <LayoutCenter margin="0px 16px 48px 16px" column>
        <HeadingComponent
          margin="48px 16px 24px 16px"
          headingText="Syarat Jadi Goers"
          fontWeight="bold"
        ></HeadingComponent>
        <LayoutCenter margin="0px">
          <GoIllusList illusList={termsList} />
        </LayoutCenter>
      </LayoutCenter>

      <style jsx>
        {`
          .hcgo-terms-wrapper {
            background-color: var(--color-white-soft);
            display: flex;
            justify-content: center;
          }
        `}
      </style>
    </div>
  );
};
